import { Directive, OnInit, input, model } from '@angular/core';

import { GridOptions } from 'ag-grid-enterprise';

import { IColOptions } from '../models/columns/base-col';
import { ContentMenuAction, IFieldsOverrides, ITreeData } from '../models/types';
import { AbstractGridComponent } from './abstract-grid.component';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { LoadingComponent } from './loading/loading.component';

@Directive()
export abstract class BaseGridComponent<T extends { id: string }> extends AbstractGridComponent<T> implements OnInit {
  fieldsOverrides = input<IFieldsOverrides>({});

  colOptions = input<IColOptions>({});

  treeData = input<ITreeData<T> | null>(null);

  openByDefault = input(true);

  contextMenuItems = input<ContentMenuAction[]>([]);

  gridOptions = model<
    Pick<
      GridOptions,
      | 'domLayout'
      | 'getRowClass'
      | 'getRowHeight'
      | 'isFullWidthRow'
      | 'fullWidthCellRenderer'
      | 'suppressDragLeaveHidesColumns'
      | 'cacheBlockSize'
      | 'pagination'
      | 'paginationPageSize'
      | 'rowSelection'
    >
  >({});

  readonly rowHeight: number = 40;
  readonly loadingCellRenderer = LoadingComponent;

  public components: {
    [p: string]: any;
  } = {
    agColumnHeader: CustomHeaderComponent,
  };

  override ngOnInit() {
    super.ngOnInit();
  }
}
